import initialMediaLibState from "../mediaLib.initialState";
import { reduxActions as MEDIA_LIB } from "_constants/mediaLib.constants";
import { FAILURE, LOADING, SUCCESS } from "_constants/redux.constants";

const post = {
  [MEDIA_LIB.POST_STARTED]: (state) => ({
    ...state,
    post: {
      ...state.post,
      status: LOADING
    }
  }),

  [MEDIA_LIB.POST_SUCCESS]: (state, { payload }) => ({
    ...state,
    post: {
      ...state.post,
      data: payload?.data ?? null,
      error: null,
      status: SUCCESS
    }
  }),

  [MEDIA_LIB.POST_FAIL]: (state, { payload }) => ({
    ...state,
    post: {
      ...state.post,
      error: payload?.error ?? null,
      status: FAILURE
    }
  }),

  [MEDIA_LIB.POST_RESET]: (state, { payload }) => ({
    ...state,
    post: initialMediaLibState
  })
};

export default post;
